export type ISrcSet = {
  x1: string;
  x2: string;
};

// 1 Row
const row1_1 = require('./1-row/row1-1.png');
const row1_1_2x = require('./1-row/row1-1-2x.png');
const row1_2 = require('./1-row/row1-2.png');
const row1_2_2x = require('./1-row/row1-2-2x.png');
const row1_3 = require('./1-row/row1-3.png');
const row1_3_2x = require('./1-row/row1-3-2x.png');
const row1_4 = require('./1-row/row1-4.png');
const row1_4_2x = require('./1-row/row1-4-2x.png');

export const row1Images: ISrcSet[] = [
  { x1: row1_1, x2: row1_1_2x },
  { x1: row1_2, x2: row1_2_2x },
  { x1: row1_3, x2: row1_3_2x },
  { x1: row1_4, x2: row1_4_2x },
];

// 2 Row
const row2_1 = require('./2-row/row2-1.png');
const row2_1_2x = require('./2-row/row2-1-2x.png');
const row2_2 = require('./2-row/row2-2.png');
const row2_2_2x = require('./2-row/row2-2-2x.png');
const row2_3 = require('./2-row/row2-3.png');
const row2_3_2x = require('./2-row/row2-3-2x.png');
const row2_4 = require('./2-row/row2-4.png');
const row2_4_2x = require('./2-row/row2-4-2x.png');

export const row2Images: ISrcSet[] = [
  { x1: row2_1, x2: row2_1_2x },
  { x1: row2_2, x2: row2_2_2x },
  { x1: row2_3, x2: row2_3_2x },
  { x1: row2_4, x2: row2_4_2x },
];

// 3 Row
const row3_1 = require('./3-row/row3-1.png');
const row3_1_2x = require('./3-row/row3-1-2x.png');
const row3_2 = require('./3-row/row3-2.png');
const row3_2_2x = require('./3-row/row3-2-2x.png');
const row3_3 = require('./3-row/row3-3.png');
const row3_3_2x = require('./3-row/row3-3-2x.png');
const row3_4 = require('./3-row/row3-3.png');
const row3_4_2x = require('./3-row/row3-4-2x.png');

export const row3Images: ISrcSet[] = [
  { x1: row3_1, x2: row3_1_2x },
  { x1: row3_2, x2: row3_2_2x },
  { x1: row3_3, x2: row3_3_2x },
  { x1: row3_4, x2: row3_4_2x },
];

export const allRowsPartners = [...row1Images, ...row2Images, ...row3Images];
